import { acceptHMRUpdate, defineStore } from "pinia";
import {shallowRef} from "vue";
import {has as _has, get as _get} from 'lodash-es';
import {printCurrencyValue, wrapArray} from "@/common-scripts/utilities";
import {useBookingStore} from "@/stores/booking";
import {useBookingStepperStore} from "@/stores/booking-stepper";
import {useDialogManagerStore} from "@/stores/dialog-manager";
import MovementDetailsDialog from "@/common-components/dialogs/movement-details-dialog.vue";


export function matchOfferServiceId(offeredService, postSaleDetail){
	return _get(offeredService, 'id.offeredServiceId') == _get(postSaleDetail, 'offeredServiceId.offeredServiceId')
		&& _get(offeredService, 'id.travelId') == _get(postSaleDetail, 'offeredServiceId.travelId')
		&& _get(offeredService, 'id.travelSolutionId') == _get(postSaleDetail, 'offeredServiceId.travelSolutionId')
}

const changeTypeFromPostActionCode = {
	'traveller_change': 'traveller_change',
	'booking_change_before_departure': 'edit-date-time',
	'travel_change_before_departure': 'travel-change',
	'refund_before_departure': 'refund',
	'change_class': 'change-class'
};

export function movementDetailsMatrix(){
	let matrix = {
		currency: 'EUR',
		dialog: null,
		thead: ['DESCRIZIONE', 'CREDITO', 'DEBITO'],
		theadMobile: ['DESCRIZIONE', 'IMPORTO'],
		/**
		 * Every array is composed from this object: { description: '', price: 0.0 }
		 */
		toCredit: [],
		toDebit: [],
		subtotal: {
			credit: null,
			debit: null,
		},
		total: {
			debit: null,
			credit: null
		}
	};
	const result = Object.assign({}, matrix);

	return result;
}

export const usePostSaleStore = defineStore('postSale', {
	state: () => ({
		loading: false,
		// searchType: 'email_pnr',		// TODO: RIPRISTINARE
		searchType: 'pnr_cp',
		reopenedTravel: shallowRef(null),
		isCarnet: false,
		rightTravelSolutions: [],	// TODO: VERIFICARE SE SERVE VERAMENTE ATTUALMENTE INVOCATO SOLO NEL BOOKING.JS
		newSearch: {
			startDate: null,
			departureStation: null,
			arrivalStation: null
		},
		selectedEdit: null,
		selectedReopenedTravelSolutionXmlId: null,
		selectedTravelSolution: null,
		selectedReturnTravelSolution: null,
		closedTravel: {
			show: false,
			thereAre: false
		},
		newTravel: {
			isSelected: false
		},
		newSolutions: {
			forward: null,
			return: null
		},
		// movementDetails: {
		// 	forward: movementDetailsMatrix(),
		// 	return: movementDetailsMatrix()
		// },
		movementDetails: {},
		/**
		 * Original object for postSale use
		 *
		 * NO selected travelSolution to view like bookingStore.selectedSolutionView, but the selected solution comprensive
		 * of validatedPostSaleRecord, reversedPaymentRecords, etc.
		 */
		selectedSolution: null,

		travelStep: null,	// string: forward | return
		reopenedTravelHaveARoundTrip: null,
		isActionForBothDirections: null,
		actionsWithRestrictions: shallowRef(["booking_change_before_departure"])
	}),
	getters: {
		travel(){
			return _get(this.reopenedTravel, 'travel');
		},
		/**
		 * The travel soluction selected for change from reopen travel
		 */
		selectedReopenedTravelSolution(state){
			if (!this.travel) return ;
			let res = null;
			for (const travelSolution of this.travel.travelSolutions) {
				if (travelSolution.xmlId == state.selectedReopenedTravelSolutionXmlId) return travelSolution;

				if(travelSolution.returnTravelSolution &&
					travelSolution.returnTravelSolution.xmlId == state.selectedReopenedTravelSolutionXmlId) return travelSolution;
			}
		},
		getTravelSolution(state) {
			if ('return' == state.travelStep) return state.selectedReturnTravelSolution;
			return state.selectedTravelSolution;

			// if (!state.reopenedTravel) return ;
			// if (Array.isArray(state.reopenedTravel.travel.travelSolutions)) {
			// 	const travelSolutions = [];
			// 	for ( const k in state.reopenedTravel.travel.travelSolutions ) {
			// 		if (!Object.hasOwnProperty.call(state.reopenedTravel.travel.travelSolutions, k)) continue;
			//
			// 		if ('CLOSED' != state.reopenedTravel.travel.travelSolutions[k].state) {
			// 			travelSolutions.push(state.reopenedTravel.travel.travelSolutions[k]);
			// 		}
			// 	}
			// 	if (travelSolutions.length > 1) {
			// 		console.error('Huston abbiamo un problema !');
			// 		return false;
			// 	} else {
			// 		return travelSolutions[0];
			// 	}
			// } else {
			// 	return state.reopenedTravel.travel.travelSolutions;
			// }
		},
		selectedTravelSolutionXmlId(state) {
			if (!this.getTravelSolution) return ;
			return this.getTravelSolution.xmlId;
		},
		selectedPostSaleDetails(state) {
			if (useBookingStepperStore().isAfterForwardTripSteps) return _get(state.reopenedTravel, ['postActions', this.selectedTravelSolutionXmlId, state.selectedEdit, 'postSaleDetails']);
			return _get(state.reopenedTravel, ['postActions', this.selectedTravelSolutionXmlId, state.selectedEdit, 'postSaleDetails']);
		},
		/**
		 * used only for debug
		 */
		postSaleDetails(state){
			if(!state.reopenedTravel || !state.reopenedTravel.reopen.postSaleDetails || !Array.isArray(state.reopenedTravel.reopen.postSaleDetails)) return {};
			const result = {};
			let psdHok;
			for (const postSaleDetail of state.reopenedTravel.reopen.postSaleDetails) {
				psdHok = postSaleDetail.postSaleType.code+':'+postSaleDetail.postSaleType.subCode;
				if(!result[psdHok]) result[psdHok] = []
				result[psdHok].push(postSaleDetail);
			}
			return result;
		},
		hasEntitlements(state){
			const entitlements = _get(state.reopenedTravel, 'travel.original.entitlements');
			return Boolean(Array.isArray(entitlements) ? entitlements.length : entitlements);
		},
		/**
		 * used only for debug
		 */
		// enabledPostSaleDetails(state){
		// 	return Object.entries(this.postSaleDetails).reduce((res, [key, val]) =>{
		// 		for (const v of val) {
		// 			if(v.allowed != 'true'){
		// 				if(!res.not_allowed) res.not_allowed = [];
		// 				res.not_allowed.push(v);
		// 				continue;
		// 			}
		// 			if(!res[key]) res[key] = [];
		// 			res[key].push(v);
		// 		}
		//
		// 		return res;
		// 	}, {});
		// },
		// /**
		//  * used only for debug
		//  */
		// postSaleDetailWithOfferedService(state){
		// 	if(!state.reopenedTravel || !state.reopenedTravel.reopen.postSaleDetails) return {};
		// 	const result = {};
		// 	for (const postSaleDetail of state.reopenedTravel.reopen.postSaleDetails) {
		// 		if(!result[postSaleDetail.postSaleType.code+':'+postSaleDetail.postSaleType.subCode]) result[postSaleDetail.postSaleType.code+':'+postSaleDetail.postSaleType.subCode] = []
		//
		// 		const res = {postSaleDetail};
		// 		res.travelSolution = state.reopenedTravel.travel.travelSolutions.find(t => {
		// 			return t.id == postSaleDetail.offeredServiceId.travelSolutionId;
		// 		});
		// 		if(res.travelSolution){
		// 			res.offeredService = Object.values(res.travelSolution.offeredServices).find(o => {
		// 				return o.original.id.offeredServiceId == postSaleDetail.offeredServiceId.offeredServiceId;
		// 			});
		// 			if(res.offeredService){
		// 				res.travellerXmlId = res.offeredService.travellerXmlId;
		// 				res.offerServiceName = state.reopenedTravel.serviceMap.offers[res.offeredService.offerId].display_name;
		// 				res.catalogServiceName = state.reopenedTravel.serviceMap.catalog_services[res.offeredService.catalogServiceId].display_name;
		// 			}
		// 		}
		//
		// 		result[postSaleDetail.postSaleType.code+':'+postSaleDetail.postSaleType.subCode].push(res);
		// 	}
		// 	return result;
		// },
		/**
		 * Remap entitlements
		 * @param {Object} state 
		 * @returns 
		 */
		entitlementsData(state){
			if(!_has(state, 'reopenedTravel.travel.original.entitlements')) return [];
			if (!Array.isArray(state.reopenedTravel.travel.original.entitlements)) state.reopenedTravel.travel.original.entitlements = [state.reopenedTravel.travel.original.entitlements];
			return state.reopenedTravel.travel.original.entitlements.filter(e => e.status != 'DELETED').
			map(e => {
				const data = { entitlement: e, offeredServices: [], travellerXmlId: null };
				let entitlementOfferedServices = e.offeredServices;
				if(typeof(entitlementOfferedServices) == 'string') entitlementOfferedServices = [entitlementOfferedServices];
				for (const offeredServiceId of entitlementOfferedServices) {
					for (const travelSolution of state.reopenedTravel.travel.travelSolutions) {
						if(!_has(travelSolution, 'offeredServices.'+offeredServiceId)) continue;
						const offeredService = _get(travelSolution, 'offeredServices.'+offeredServiceId);
						data.offeredServices.push(offeredService);
						data.travellerXmlId = offeredService.travellerXmlId
					}
				}
		
				return data;
			});
		},
		/**
		 * Used for associate post sale details to offered services
		 * @returns 
		 */
		offeredServicesMap(state){
			const offeredServicesMap = new Map();
			if(!_has(state, 'reopenedTravel.travel.travelSolutions')) return [];
			if(!this.getTravelSolution) return [];

			if (this.isForwardReturnFlow) {
				for (const [offeredServiceId, offeredService] of Object.entries(state.selectedTravelSolution.offeredServices)) {
					offeredServicesMap.set([offeredService.original.id.offeredServiceId, offeredService.original.id.travelId, offeredService.original.id.travelSolutionId].join(':'), offeredService);
				}
				for (const [offeredServiceId, offeredService] of Object.entries(state.selectedReturnTravelSolution.offeredServices)) {
					offeredServicesMap.set([offeredService.original.id.offeredServiceId, offeredService.original.id.travelId, offeredService.original.id.travelSolutionId].join(':'), offeredService);
				}
			} else {
				for (const [offeredServiceId, offeredService] of Object.entries(this.getTravelSolution.offeredServices)) {
					offeredServicesMap.set([offeredService.original.id.offeredServiceId, offeredService.original.id.travelId, offeredService.original.id.travelSolutionId].join(':'), offeredService);
				}
			}


			return offeredServicesMap;
		},
		isValidEvaluate(state){
			return ['true', true].includes(_get(this.getNewSolutions, 'postSaleRecord.allowed'));
		},
		requireTransaction(state){
			if (this.getNewSolutions && _get(this.getNewSolutions, 'missingAmount.amount')) {
				const missingAmount = _get(this.getNewSolutions, 'missingAmount.amount');
				if (!missingAmount) return true;
				return parseFloat(missingAmount) > 0;
			} else {
				return !state.movementDetails.isFree;
			}
		},
		getNewSolutions(state) {
			return state.newSolutions[state.travelStep];
		},
		newForwardTravelSolution(state) {
			if (!state.newSolutions.forward) return;
			if (state.newSolutions.forward.travel) {
				for (let travelSolution of state.newSolutions.forward.travel.travelSolutions) {
					if ('NEW' == travelSolution.state) {
						return  travelSolution;
					}
				}
			} else if (state.newSolutions.forward.travelSolution) {
				return _get(state.newSolutions.forward, 'travelSolution', state.newSolutions.forward);
			}
		},
		newReturnTravelSolution(state) {
			if (!state.newSolutions.return) return;
			if (state.newSolutions.return.travel) {
				for (let travelSolution of state.newSolutions.return.travel.travelSolutions) {
					if ('NEW' == travelSolution.state) {
						return  travelSolution;
					}
				}
			} else if (state.newSolutions.return.travelSolution) {
				return _get(state.newSolutions.return, 'travelSolution', state.newSolutions.return);
			}
		},
		newReturnTravelSolutionXmlId() {
			if (!this.newReturnTravelSolution) return ;
			return this.newReturnTravelSolution.xmlId;
		},
		/**
		 * Premessa: il flusso di trenitalia prevede che il bookingChange di un A/R sia fatto con 2 chiamate separate.
		 *
		 * Nel caso in cui una delle due chiamate non vada a buon fine non sappiamo ancora come gestire il flusso parziale,
		 * specialmente lato WooCommerce, ai fini fiscali ed economici; per questo per il momento per certe operazioni post sale
		 * in A/R permettiamo solo quelle gratuite che non producono flussi economici.
		 *
		 * @type {ComputedRef<unknown>}
		 */
		operationIsAvailable(state) {
			if (!state.isActionForBothDirections) return true;
			if (!state.actionsWithRestrictions.includes(state.selectedEdit)) return true;
			if(!this.requireTransaction) return true;

			return false;
		},
		isForwardReturnFlow(state) {
			return state.reopenedTravelHaveARoundTrip && state.isActionForBothDirections;
		}
	},
	actions: {
		async reopenTravel(data) {
			if('true' == import.meta.env.VITE_CACHE_REOPENTRAVEL){
				let reop = sessionStorage.getItem('reopened-travel');
				if (reop) {
					this.reopenedTravel = JSON.parse(reop);

					this.rightTravelSolutions = [];
					for (let travelSolution of this.reopenedTravel.travel.travelSolutions) {
						if ('FINALIZED' != travelSolution.state) continue;

						// USO QUESTO PER IMPOSTARE IL PRIMO TRAVEL SOLUTION E NON L'ULTIMO
						if (Object.is(this.reopenedTravelHaveARoundTrip, null)) this.reopenedTravelHaveARoundTrip = Boolean(travelSolution.returnTravelSolution && 'CLOSED' != travelSolution.returnTravelSolution.state);
						this.rightTravelSolutions.push(travelSolution);
					}
					useBookingStepperStore().switchRoundTripStatus(this.reopenedTravelHaveARoundTrip);

					return this.reopenedTravel;
				}
			}
			this.loading = 'search';
			return this.$axios.post('trenitalia/search-booked-travels', data)
				.then((res) => {
					this.reopenedTravel = res.data;
					this.rightTravelSolutions = [];
					for (let travelSolution of this.reopenedTravel.travel.travelSolutions) {
						if ('FINALIZED' != travelSolution.state) continue;

						// USO QUESTO PER IMPOSTARE IL PRIMO TRAVEL SOLUTION E NON L'ULTIMO
						if (Object.is(this.reopenedTravelHaveARoundTrip, null)) this.reopenedTravelHaveARoundTrip = Boolean(travelSolution.returnTravelSolution && 'CLOSED' != travelSolution.returnTravelSolution.state);
						this.rightTravelSolutions.push(travelSolution);
					}
					this.isCarnet = res.data.isCarnet || false;
					useBookingStepperStore().switchRoundTripStatus(this.reopenedTravelHaveARoundTrip);
					useBookingStore().updateServicesMap(this.reopenedTravel.serviceMap);

					// TODO: DA CANCELLARE
					if('true' == import.meta.env.VITE_CACHE_REOPENTRAVEL) sessionStorage.setItem('reopened-travel', JSON.stringify(res.data));

					return res.data;
				})
				.catch(e => {
					if (_get(e, 'response.data.details')) {
						useDialogManagerStore().showErrorReadingErrorDetails(e);
					} else if ('CLOSED' == _get(e, 'response.data.search.travelSummaries.state')) {
						let messages = [];
						if (!Array.isArray(e.response.data.search.travelSummaries.travelSolutionDescriptions)) e.response.data.search.travelSummaries.travelSolutionDescriptions = [e.response.data.search.travelSummaries.travelSolutionDescriptions];
						for (let travelSolutionDescription of e.response.data.search.travelSummaries.travelSolutionDescriptions) {
							messages.push(
								travelSolutionDescription.description + ' del ' + travelSolutionDescription.date + ' => ' +
								'<span class="text-red">' + travelSolutionDescription.state + '</span>'
							)
						}
						useDialogManagerStore().showErrorDialogFromError(e, {
							title: this.$i18n.t('stores.postsale.reopentravel.travel_closed', 'Il viaggio cercato è stato chiuso. Seguono dettagli') + ':',
							messageHTML: messages.join('<hr style="margin: 3% 0;">'),
							showOK: true
						});
					} else if(404 == _get(e, 'response.status')) {
						useDialogManagerStore().showErrorDialogFromError(e, {
							title: this.$i18n.t('dialogs.warning'),
							message: this.$i18n.t('stores.postsale.reopentravel.travel_not_found', 'Non è stato trovato il viaggio, per favore controllare i parametri inseriti.'),
						});
					} else {
						useDialogManagerStore().showErrorDialogFromError(e, {
							title: this.$i18n.t('dialogs.warning'),
							message: this.$i18n.t('stores.postsale.reopentravel.travel_not_results', 'La ricerca non ha prodotto risultati'),
						});
					}
				}).then((r) => {
					this.loading = false;
					return r;
				});
		},
		/**
		 * Non è mai usato operationType, è usato solo per il cambio classe
		 * @param operationType		=>	routingChange (cambio completo del biglietto) | ticketChange (upgrade di classe)
		 * @returns {Promise<*|boolean>}
		 */
		async ticketChange() {
			const booking = useBookingStore();
			const dialog = useDialogManagerStore();
			const comunication = dialog.showLoadingDialog({
				titleAlign: 'center',
				title: this.$i18n.t('stores.postsale.ticketchange.price_search', 'Ricerca prezzi...'),
			});

			try{
				const dataToSend = {
					reopenedTravel: this.reopenedTravel.travel.original,
					operationType: 'ticketChange',
					selectedPostSaleDetails: this.getTravelSolutionPostActions(this.selectedTravelSolutionXmlId).travel_change_before_departure.postSaleDetails
					// selectedPostSaleDetails: this.reopenedTravel.postActions.travel_change_before_departure.postSaleDetails
				}
				const response = await this.$axios.post('trenitalia/post-sale/travel-change', dataToSend);

				// this.selectedSolution = response.data;
				this.selectNewTravelSolution(response.data);

				let newViewItems = booking.elaborateSearchResponseWithReturnTravelSolutions(response);
				newViewItems = newViewItems[0];

				// TODO: UNIFORMARE IL SELECTEDTRAINGRIDOFFER CON SELECTEDCUSTOMIZEDOFFER
				// if (!booking.passengers) booking.passengers = [];
				
				await Promise.resolve(); // wait for getters to be updated
				return newViewItems;
			}catch(e){
				// check if is a axios response error
				if (_has(e, 'response.data.details')) {
					await dialog.showErrorReadingErrorDetails(e);
				}else{
					await dialog.openSimpleMessageDialog({
						messageType: 'error',
						title: this.$i18n.t('dialogs.warning'),
						text: _get(e, 'message', this.$i18n.t('dialogs.errors.unexpected_error'))
					});
				}

				console.error(e);
				return false;
			}finally{
				comunication.close();
			}
		},
		/**
		 *
		 * @param travel					=> reopened travel
		 * @param selectedPostSaleDetails	=> the type of post sale changes (eg. travel change, name change, class upgrade, ...)
		 * @param selectedOfferedServices	=> offer and service selected (the price of travelSolution selected)
		 * @param additionalCharges			=> eventualy additional charges
		 *
		 * @returns {Promise<{success}|T>}
		 */
		async evaluateTravel({newTravelSolutionSelected, selectedOfferedServices = null, operationType = null, withSeatsSelection = false} = {}) {
			const booking = useBookingStore();
			const comunication = useDialogManagerStore().showLoadingDialog({
				titleAlign: 'center',
				title: this.$i18n.t('stores.postsale.evaluatetravel.check', 'Controllo...')
			});

			const is_valid = await this.checkAndSetCartaFrecciaForTravellers();
			if (!is_valid) {
				comunication.close();
				return false;
			}

			if(!newTravelSolutionSelected) newTravelSolutionSelected = _get(booking.selectedSolutionView, 'original');
			// if(!selectedOfferedServices) selectedOfferedServices = booking.selectedOffers;
			if(!selectedOfferedServices) selectedOfferedServices = booking.selectedOffersData;

			const dataToSend = {
				travel: this.reopenedTravel.travel.original,
				newTravelSolutionSelected,
				selectedPostSaleDetails: this.selectedPostSaleDetails,
				selectedOfferedServices: selectedOfferedServices,
				additionalCharges: this.reopenedTravel.additionalCharges || null,
				withSeatsSelection: withSeatsSelection
			}

			if (this.isForwardReturnFlow && useBookingStepperStore().inReturnPages) {
				if ('change_class' != this.selectedEdit) {
					dataToSend.newTravelSolutionSelected = this.newForwardTravelSolution;
					dataToSend.newTravelSolutionSelected.returnTravelSolution = newTravelSolutionSelected;
				}
				dataToSend.selectedOfferedServices = [...this.newSolutions.forward.selectedOfferedServices, ...selectedOfferedServices];
				dataToSend.selectedPostSaleDetails = [...this.newSolutions.forward.selectedPostSaleDetails, ...this.selectedPostSaleDetails];
				if (!withSeatsSelection && this.newSolutions.forward.withSeatsSelection) dataToSend.withSeatsSelection = true;
			}

			try{
				const response = await this.$axios.post('trenitalia/post-sale/evaluate', dataToSend);

				if(!response.data.validatedPostSaleRecord) {
					if (response.data.details) {
						await useDialogManagerStore().showErrorReadingErrorDetails(e);
					}
					throw new Error(_get(response, 'data.message', 'Unexpected error (cod.ET-01).'));
				}
				if(['false', false].includes(response.data.validatedPostSaleRecord.allowed)) {
					let message = withSeatsSelection ? this.$i18n.t('stores.postsale.evaluatetravel.not_allowed.wihtseatselection', 'Siamo spiacenti ma non è possibile selezionare un posto a sedere') : '';

					if (response.data.validatedPostSaleRecord.messages && response.data.validatedPostSaleRecord.messages.length > 0) {
						message = Array.isArray(response.data.validatedPostSaleRecord.messages) ?
							response.data.validatedPostSaleRecord.messages.join('. ') : response.data.validatedPostSaleRecord.messages;
					}
					if (withSeatsSelection) {
						booking.setRequestSeatSelection(false);
						await useDialogManagerStore().openSimpleMessageDialog({
							messageType: 'error',
							title: this.$i18n.t('dialogs.warning'),
							text: message,
						}, true);

						return ;
					} else {
						throw new Error(message || this.$i18n.t('stores.postsale.evaluatetravel.not_allowed.default', 'Errore inatteso'));
					}
				}

				response.data.postSaleRecord = response.data.validatedPostSaleRecord;
				delete response.data.validatedPostSaleRecord;

				if (!Array.isArray(response.data.travel.travelSolutions)) response.data.travel.travelSolutions = [response.data.travel.travelSolutions];
				this.selectNewTravelSolution(JSON.parse(JSON.stringify(response.data)), dataToSend.selectedOfferedServices, dataToSend.selectedPostSaleDetails, withSeatsSelection);
				booking.setEvaluatedSolution({
					serviceMap: this.getNewSolutions.servicesMap,
					trainSeatMaps: this.getNewSolutions.trainSeatMaps,
					viewTravelSolutions: this.getNewSolutions.viewTravelSolutions,
					travelSolutions: this.getNewSolutions.travel.travelSolutions,
				});
				delete this.getNewSolutions.servicesMap;
				delete this.getNewSolutions.trainSeatMaps;
				delete this.getNewSolutions.viewTravelSolutions;
				delete this.getNewSolutions._invalid_traveller_parameters;
				delete this.getNewSolutions.saleabilityMessages;

				// Calculate movement details
				this.setMovementDetailsToShowDialog(null, operationType);

				await Promise.resolve(); // wait for getters to be updated

				return response.data;
			}catch(e){
				console.error(e);
				// check if is a axios response error
				if (_has(e, 'response.data.details')) {
					await useDialogManagerStore().showErrorReadingErrorDetails(e);
				}else{
					await useDialogManagerStore().showErrorDialogFromError({
						messageType: 'error',
						title: this.$i18n.t('dialogs.warning'),
						message: _get(e, 'message', this.$i18n.t('dialogs.errors.unexpected_error'))
					});
				}
				throw new Error(e);
			}finally{
				comunication.close();
			}
		},
		async checkAndSetCartaFrecciaForTravellers() {
			const booking = useBookingStore();

			for(const passenger of booking.passengers) {
				passenger.data.cartaFrecciaErr = false;
				if (!passenger.data.cartaFreccia || passenger.data.customerKey) continue;
				const response = await this.$axios.post('trenitalia/post-sale/validate-cartafreccia', {
					passengers: [passenger]
				}).catch(e => {
					return false;
				});

				if (!response) {
					// passenger.data.cartaFreccia = null;
					passenger.data.cartaFrecciaErr = true;
					await useDialogManagerStore().showErrorDialogFromError({
						messageType: 'error',
						title: this.$i18n.t('dialogs.warning'),
						message: 'CartaFreccia errata.'
					});

					return false
				}

				if (!response.data.is_valid) {
					passenger.data.cartaFrecciaErr = true;
					await useDialogManagerStore().showErrorDialogFromError({
						messageType: 'error',
						title: this.$i18n.t('dialogs.warning'),
						message: 'Il nome del/i passeggero/i non corrispone al numero di CartaFreccia inserito/i. Si consiglia di controllare o fare un cambio nominativo del/i passeggero/i.'
					});

					return false
				}

				this.reopenedTravel.travel.original.travellers = this.reopenedTravel.travel.original.travellers.map((traveller) => {
					if (traveller.xmlId == passenger.data.xmlId) {
						traveller.cartafreccia = passenger.data.cartaFreccia;
					}
					return traveller;
				});
			}

			return true;
		},
		/**
		 *
		 * @param data						=> { travel: reopenedTravel, data: {
		 * 																		postSaleRecord: '',
		 * 																		reversedPaymentRecords: '',
		 * 																		reusedPaymentRecords: '',
		 * 																		additionalCharges: '',
		 * 																		missingAmount: ''
		 * 																	 } }
		 * @param loadingMessage
		 * @param successDialogMessage
		 * @param errorDialogMessage
		 * @returns {Promise<{success}|T|*>}
		 */
		async addToCartPostSale(data = null, { operationType = null, loadingMessage = null, successDialogMessage = null, errorDialogMessage = null, zeroTransactions = false, isReturnOfAR = null, direction = null } = {}) {
			if(import.meta.env.VITE_DISABLE_TANGERINE){
				const response = this.$axios.post('trenitalia/post-sale/complete-from-evaluate', data)
				return response.data;
			}
			const dialog = useDialogManagerStore();
			const comunication = dialog.showLoadingDialog({
				titleAlign: 'center',
				title: loadingMessage || this.$i18n.t('stores.postsale.addtocartpostsale.proceed', 'Procedo con l\'operazione...')
			});

			try{
				if (!data && this.isValidEvaluate) {
					let d = JSON.parse(JSON.stringify(this.getNewSolutions));
					const travel = d.travel;
					delete d.travel;
					// todo: save more info like travellers change, see on angular tangerine
					d.changeDetail = {
						changeType: _get(changeTypeFromPostActionCode, this.selectedEdit, 'undefined'),
						post_sale_action: this.selectedEdit
					};
					data = {
						travel: travel,
						data: d
					}
				}
				if(import.meta.env.DEV ){
					if (!data.data || !data.travel) throw new Error('Missed data - cod.ATCPS-01');
					data.confirm = true;
				}

				if (data.data.trainSeatMaps) {
					delete data.data.trainSeatMaps;
					data.data.seatMap = useBookingStore().setSeatMapDataToAddToCart();
				}
				data.data.changeType = this.selectedEdit;
				data.data.operationType = operationType;
				data.data.direction = direction || this.travelStep;


				let endpoint = 'trenitalia/add-to-cart-postsale';
				if(zeroTransactions){
					endpoint = 'trenitalia/post-sale/update';
					data.confirm = true; // zero transaction must always confirm
				}

				let response;
				if('true' == import.meta.env.VITE_SKIP_PAYMENT) {
					console.log('dataToSend', data);
					console.log('endpoint', endpoint);
					response = { data: { success: true} }
				} else {
					response = await this.$axios.post(endpoint, data);
				}


				if(!zeroTransactions && !response.data.success) throw new Error(response.data.message || 'Unexpected error.');

				if (isReturnOfAR === null) isReturnOfAR = (['traveller_change'].includes(this.selectedEdit) || useBookingStepperStore().isAfterForwardTripSteps) ? true : false;
				if (this.isForwardReturnFlow && !isReturnOfAR) return response.data;

				const successDialogPromise = await dialog.openSimpleMessageDialog({
					messageType: 'success',
					title: successDialogMessage || this.$i18n.t('dialogs.success', 'Operazione effettuata con successo !')
				});

				this.backToHome(response, zeroTransactions || import.meta.env.DEV ? successDialogPromise : null);

				return true;
			}catch(e){
				console.error(e);
				// check if is a axios response error
				if (_has(e, 'response.data.details')) {
					dialog.showErrorReadingErrorDetails(e);
				}else{
					dialog.openSimpleMessageDialog({
						messageType: 'error',
						title: this.$i18n.t('dialogs.warning'),
						text: _get(e, 'message', this.$i18n.t('dialogs.errors.unexpected_error'))
					});
				}
				return false;
			}finally{
				comunication.close();
			}
		},
		async onRefund(){
			const evaluated = await this.evaluateTravel({operationType: 'refund'});
			if (!this.isValidEvaluate) return false;
			const r = await this.showDialogOfMovementDetails();
			if ('movementAccepted' == r.result) {
				await this.addToCartPostSale(null, {operationType: 'refund', zeroTransactions: true});
			} else {
				this.backToReopenedPage();
			}
		},

		getTravelSolutionPostActions(travelSolutionXmlId) {
			return _get(this.reopenedTravel, ['postActions', travelSolutionXmlId], {});
		},
		getTicketDescriptionFromTravelSolutionData(ts, offer) {
			const booking = useBookingStore();
			let departure = new Date(ts.departure);
			let arrival = new Date(ts.arrival);
			let travellersNum = booking.selectedSolutionView ? booking.passengers.length : this.reopenedTravel.travel.travellers.length;
			let denomination = !ts.denomination || 'undefined' == ts.denomination ? '' : ts.denomination;
			if(offer) travellersNum = 1; // offer is only for one traveller

			return denomination + ' ' + this.$i18n.t('stores.postsale.getticketdescriptionfromtravelsolutiondata.from', 'da') +
				' ' + ts.start.stationName + ' (' +
				departure.toLocaleTimeString(undefined, {hour:'2-digit', minute: '2-digit'}) +
				') ' + this.$i18n.t('stores.postsale.getticketdescriptionfromtravelsolutiondata.to', 'a') + ' ' +
				ts.end.stationName + ' (' + arrival.toLocaleTimeString(undefined, {hour:'2-digit', minute: '2-digit'}) +
				') ' + this.$i18n.t('stores.postsale.getticketdescriptionfromtravelsolutiondata.for', 'per') +
				' ' + travellersNum + ' ' + this.$i18n.t('common.people', travellersNum);
		},
		setMovementDetailsToShowDialog(data = null, operationType = null) {
			if (!data) {
				data = JSON.parse(JSON.stringify(this.getNewSolutions));
				data.travelSolutions = data.travel.travelSolutions
				delete data.travel;
			}

			let travelSolutions = data.travelSolutions || data.travelSolution;
			if (!Array.isArray(travelSolutions)) travelSolutions = [travelSolutions];

			const booking = useBookingStore();
			let movementDetails = movementDetailsMatrix();
			let price;
			const postSaleRecord = data.validatedPostSaleRecord || data.postSaleRecord;
			movementDetails.currency = postSaleRecord.totalValue.currency;
			let currency = null;
			let credit = 0.0;
			let debit = 0.0;


			// Eventuale rimborso
			const totalReversedAmount = wrapArray(data.reversedPaymentRecords).reduce((carry, reverseRecord) => {
				return carry + parseFloat(_get(reverseRecord, 'amount.amount', 0));
			}, 0);

			movementDetails.isFree = parseFloat(_get(data, 'missingAmount.amount', 0)) == 0 && totalReversedAmount == 0;
			movementDetails.isRefund = parseFloat(_get(data, 'missingAmount.amount', 0)) < totalReversedAmount;


			// Prodotti già acquistati
			price = printCurrencyValue(parseFloat(postSaleRecord.totalValue.amount), postSaleRecord.totalValue.currency);
			movementDetails.toCredit.push({
				description: this.$i18n.t('stores.postsale.setmovementdetailstoshowdialog.purchased_products', 'Prodotti/servizi acquistati'),
				price: price
			});
			movementDetails.subtotal.credit = price;
			credit += parseFloat(postSaleRecord.totalValue.amount);


			// Penalities
			if (parseFloat(postSaleRecord.totalPenalties.amount) > 0) {
				price = printCurrencyValue(parseFloat(postSaleRecord.totalPenalties.amount), postSaleRecord.totalPenalties.currency);
				movementDetails.toDebit.push({
					description: this.$i18n.t('stores.postsale.setmovementdetailstoshowdialog.penalties', 'Penali'),
					price: price
				});
				debit += parseFloat(postSaleRecord.totalPenalties.amount);
			}

			if(operationType && 'refund' == operationType) {
				movementDetails.total.credit = printCurrencyValue(totalReversedAmount, movementDetails.currency);
				movementDetails.subtotal.debit = printCurrencyValue(debit, currency);
				this.movementDetails = movementDetails;
				return;
			}


			// Prodotti da acquistare
			const toPurchase = booking.selectedSolutionView || this.newSolutions.return ? this.newSolutions.return : this.newSolutions.forward;
			if (toPurchase) {
				function getSelectedOfferedServicesPrices(travelSolutions, selectedEdit) {
					if (!Array.isArray(travelSolutions)) travelSolutions = [travelSolutions];
					function sumPrices(offeredServices) {
						let price = 0.0;
						for (let offeredService of offeredServices) {
							if (!offeredService.status) {
								for (let i in offeredService) {
									if (!Object.hasOwnProperty.call(offeredService, i)) continue;
									if (!offeredService[i].price) throw new Error('setMovementDetailsToShowDialog2');
									if ('SELECTED' !== offeredService[i].status) continue;

									price += parseFloat(offeredService[i].price.amount);
								}
							} else {
								if ('SELECTED' !== offeredService.status) continue;

								price += parseFloat(offeredService.price.amount);
							}
						}
						return price;
					}
					let currency = null;
					let price = 0.0;

					for (let travelSolution of travelSolutions) {
						if ('change_class' != selectedEdit && 'NEW' != travelSolution.state) continue;
						if ('change_class' == selectedEdit && 'FINALIZED' != travelSolution.state) continue;
						if (!Array.isArray(travelSolution.offeredServices)) travelSolution.offeredServices = [travelSolution.offeredServices];
						if (!currency) {
							if (travelSolution.offeredServices[0].price) {
								currency = travelSolution.offeredServices[0].price.currency;
							} else {
								for (let i in travelSolution.offeredServices[0]) {
									if (!Object.hasOwnProperty.call(travelSolution.offeredServices[0], i)) continue;
									if (!travelSolution.offeredServices[0][i].price) throw new Error('setMovementDetailsToShowDialog');
									currency = travelSolution.offeredServices[0][i].price.currency;
									break;
								}
							}
						}

						price += sumPrices(travelSolution.offeredServices);
						if (travelSolution.returnTravelSolution) {
							if (!Array.isArray(travelSolution.returnTravelSolution.offeredServices)) travelSolution.returnTravelSolution.offeredServices = [travelSolution.returnTravelSolution.offeredServices];
							price += sumPrices(travelSolution.returnTravelSolution.offeredServices);
						}
					}

					return {price: price, currency: currency};
				}

				const travelSolution = toPurchase.travel ? toPurchase.travel.travelSolutions : [toPurchase.travelSolution];
				let tmp = getSelectedOfferedServicesPrices(travelSolution, this.selectedEdit);

				movementDetails.toDebit.push({
					// description: this.getTicketDescriptionFromTravelSolutionData(booking.selectedSolutionView, offer),
					description: this.$i18n.t('stores.postsale.setmovementdetailstoshowdialog.to_purchase', 'Prodotti/servizi da acquistare'),
					price: printCurrencyValue(tmp.price, tmp.currency)
				});
				debit += tmp.price;
			}


			// Spese aggiuntive
			if (data.additionalCharges) {
				if (!Array.isArray(data.additionalCharges)) data.additionalCharges = [data.additionalCharges];
				for (let additionalCharge of data.additionalCharges) {
					price = parseFloat(additionalCharge.amount.amount);
					movementDetails.toDebit.push({
						description: this.$i18n.t('stores.postsale.setmovementdetailstoshowdialog.additional_charges', 'Spese aggiuntive'),
						price: printCurrencyValue(price, additionalCharge.amount.currency)
					});
					if (!currency) currency = additionalCharge.amount.currency;
					debit += price;
				}
			}


			// Da pagare -> Missing Amount
			if (data.missingAmount && parseFloat(data.missingAmount.amount) > 0) {
				data.missingAmount.amount = parseFloat(data.missingAmount.amount);
				movementDetails.total.debit = printCurrencyValue(data.missingAmount.amount, data.missingAmount.currency);
				// TODO: CONTROLLARE CHE LA DESCRIPTION NN SIA RIPETUTA CON I "Prodotti da acquistare"
				// movementDetails.toDebit.push({
				// 	description: this.$i18n.t('stores.postsale.setmovementdetailstoshowdialog.to_purchase', 'Prodotti/servizi da acquistare'),
				// 	price: printCurrencyValue(data.missingAmount.price, data.missingAmount.currency)
				// });
			}


			// Eventuale rimborso
			if (totalReversedAmount > 0) {
				movementDetails.total.credit = printCurrencyValue(totalReversedAmount, movementDetails.currency);
			} else {
				const tot = credit - debit;
				if (tot < 0) {
					if (!movementDetails.total.debit ) movementDetails.total.debit = printCurrencyValue(tot, currency);
				} else {
					movementDetails.total.credit = printCurrencyValue(tot, currency);
				}
			}


			movementDetails.subtotal.debit = printCurrencyValue(debit, currency);


			this.movementDetails = movementDetails;
		},
		setReturnSearchCriteriaAndGoNext() {
			const booking = useBookingStore();
			booking.searchFilters.departureStation = this.selectedReopenedTravelSolution.returnTravelSolution.start;
			booking.searchFilters.arrivalStation = this.selectedReopenedTravelSolution.returnTravelSolution.end;
			booking.searchFilters.startDate = this.selectedReopenedTravelSolution.returnTravelSolution.departure;
			useBookingStepperStore().goNext();
		},

		selectTravelSolution(travelSolution) {
			if('forward' == this.travelStep) {
				this.selectedTravelSolution = travelSolution;
				if (travelSolution.returnTravelSolution && 'CLOSED' != travelSolution.returnTravelSolution.state) {
					this.selectedReturnTravelSolution = travelSolution.returnTravelSolution;
					this.reopenedTravelHaveARoundTrip = true;
				}
			} else if ('return' == this.travelStep) {
				this.selectedReturnTravelSolution = travelSolution;
			}
		},
		selectNewTravelSolution(maybeEvaluatedTravelSolution, selectedOfferedServices, selectedPostSaleDetails, withSeatsSelection) {
			const ts = JSON.parse(JSON.stringify(maybeEvaluatedTravelSolution));
			if (ts.validatedPostSaleRecord) {
				// ts.postSaleDetails = ts.validatedPostSaleRecord;
				ts.postSaleRecord = ts.validatedPostSaleRecord;
				delete ts.validatedPostSaleRecord;
			}

			if (ts.debug) delete ts.debug;
			if (ts.serviceMap) {
				useBookingStore().updateServicesMap(ts.servicesMap);
				delete ts.servicesMap;
			}

			this.newSolutions[this.travelStep] = ts;
			this.newSolutions[this.travelStep].selectedOfferedServices = selectedOfferedServices || null;
			this.newSolutions[this.travelStep].selectedPostSaleDetails = selectedPostSaleDetails || null;
			this.newSolutions[this.travelStep].withSeatsSelection = withSeatsSelection || null;
		},
		selectPostAction(actionKey, travelSolutionXmlId, isActionForBothDirections) {
			this.isActionForBothDirections = isActionForBothDirections;
			useBookingStepperStore().step = this.travelStep + '-search';

			let postAction = _get(this.reopenedTravel, ['postActions', travelSolutionXmlId, actionKey]);
			this.selectedEdit = actionKey;
			this.closedTravel.show = false;
			this.completeBookingStoreDataWithpostSale(this.getTravelSolution, postAction.postSaleDetails);
			if(actionKey == 'refund_before_departure' || actionKey == 'carnet_refund'){
				this.onRefund().catch(e => {
					console.error('onRefund', e);
					this.resetThis();
				});
			}
		},

		completeBookingStoreDataWithpostSale(rightTravelSolution, postSaleDetails) {
			const bookingStore = useBookingStore();

			bookingStore.searchFilters.departureStation = {
				name: rightTravelSolution.start.stationName,
				service_id: rightTravelSolution.start.id
			};
			bookingStore.searchFilters.arrivalStation = {
				name: rightTravelSolution.end.stationName,
				service_id: rightTravelSolution.end.id
			};
			bookingStore.setStartDate(new Date(_get(rightTravelSolution, 'original.context.searchCriteria.departureTimesStart')));
			bookingStore.searchFilters.adult = 0;
			bookingStore.searchFilters.children = 0;

			const travellers = [];
			const travellerXmlIds = new Set();
			for (const postSaleDetail of postSaleDetails) {
				const offeredService = Object.values(rightTravelSolution.offeredServices).find(o => {
					return matchOfferServiceId(o.original, postSaleDetail)
				});
				if(!offeredService) continue;
				travellerXmlIds.add(offeredService.travellerXmlId);
			}

			for (const traveller of this.travel.travellers ) {
				if(!travellerXmlIds.has(traveller.xmlId)) continue;

				bookingStore.searchFilters.adult += 'ADULT' == traveller.type ? 1 : 0;
				bookingStore.searchFilters.children += 'CHILDREN' == traveller.type ? 1 : 0;

				travellers.push(traveller);
			}

			bookingStore.searchTravellers = travellers;
			bookingStore.resetTravellers(travellers);
		},
		thereAreSomePostAction(travelSolutionXmlId) {
			let check = false;
			if (this.reopenedTravel) {
				for (let k in this.reopenedTravel.postActions[travelSolutionXmlId]) {
					if (!Object.hasOwnProperty.call(this.reopenedTravel.postActions[travelSolutionXmlId], k)) continue;
					if (true == this.reopenedTravel.postActions[travelSolutionXmlId][k].enabled) {
						check = true;
						break;
					}
				}
			}

			return check;
		},
		postSaleActions(travelSolutionXmlId){
			return _get(this.reopenedTravel, 'postActions['+travelSolutionXmlId+']', {});
		},


		backToHome(response, successDialogPromise) {
			const redirect = () => {
				this.resetAll();
				setTimeout(() =>{
					if(_has(response, 'data.redirect_url')) window.top.location.href = _get(response, 'data.redirect_url');
					else window.top.location.reload(); // todo: reoad same travel??
				}, 100);
			}

			// wait dialog close for redirect
			// if(successDialogPromise && typeof successDialogPromise === 'object' && successDialogPromise !== null){
			// 	if ('cancel' != successDialogPromise.result) successDialogPromise.then(() => redirect());
			// }else{
			redirect();
			// }
		},
		backToReopenedPage() {
			const reopenedTravel = this.reopenedTravel;
			this.exitFromPostSaleFlow();
			this.reopenedTravel = reopenedTravel;
		},

		resetThis() {
			const booking = useBookingStore();
			const reopenedTravel = this.reopenedTravel;
			const selectedEdit = this.selectedEdit;
			const selectedTravelSolution = this.selectedTravelSolution;

			this.$reset();
			this.reopenedTravel = reopenedTravel;
			if (Object.is(this.reopenedTravelHaveARoundTrip, null)) {
				let reopenedTravelHaveARoundTrip = null;
				for (const travelSolution of reopenedTravel.reopen.travel.travelSolutions) {
					if(!travelSolution.returnTravelSolution) continue;
					if('FINALIZED' !== travelSolution.returnTravelSolution.state) continue;
					reopenedTravelHaveARoundTrip = true;
				}
				if (reopenedTravelHaveARoundTrip === null) reopenedTravelHaveARoundTrip = false;
				this.reopenedTravelHaveARoundTrip = reopenedTravelHaveARoundTrip;
			}
			let searchFilters;
			if ('travel_change_before_departure' != selectedEdit) searchFilters= booking.searchFilters;

			booking.$reset();
			if ('travel_change_before_departure' != selectedEdit) booking.searchFilters = searchFilters;
			if ('travel_change_before_departure' == selectedEdit) useBookingStepperStore().step = 'search';
			this.selectTravelSolution(selectedTravelSolution);
		},
		resetAll() {
			this.$reset();
			useBookingStore().$reset();
		},
		exitFromPostSaleFlow() {
			useBookingStore().reset();
			this.$reset();
			useBookingStepperStore().$reset();
		},
		async showDialogOfMovementDetails(data = null) {
			if (data) this.setMovementDetailsToShowDialog(data);

			return useDialogManagerStore().openSimpleMessageDialog(this.movementDetails, true, MovementDetailsDialog);
		},
		/**
		 *
		 * @param travelType	=> forward | return
		 * @returns {Promise<any>}
		 */
		async errorDialog_addToCartFR(travelType = '') {
			return await useDialogManagerStore().openSimpleMessageDialog({
				messageType: 'error',
				title: this.$i18n.t('dialogs.warning'),
				text: this.$i18n.t('postsale.postsale.sorry1', "Siamo spiacenti, ma le modifiche al viaggio di") +
					' ' + travelType + ' ' +
					this.$i18n.t('postsale.postsale.sorry2', "non sono andate a buon fine. Suggeriamo di effettuare i cambi separatamente (per l'andata e/o per il ritorno) oppure rivolgersi direttamente a Trenitalia. Grazie.")
			});
		},
		fetchTravelChangePossibilities(postSaleDetails){
			return this.$axios.post('trenitalia/check-travel-change-possibilities', {
				travel: this.reopenedTravel.travel.original,
				postSaleDetails
			});
		}
	}
});

if(import.meta.hot){
	import.meta.hot.accept(acceptHMRUpdate(usePostSaleStore, import.meta.hot));
}